export default "__VITE_ASSET__d2cf182b__"